import api from "../utils/api";
const state =  {
     Record:[], 
  };

const  mutations ={
    // getList(state,catgo){
    //  state.catList = catgo.attrsList
    //  state.catLists= catgo.goodsList
    // }
    getli(state,getlistse){
          state.Record.push(getlistse)
    }


};

const  actions = {
     
  
}
const  getters = {};
export default{
    state,
    mutations,
    actions,
    getters
    
}